module.exports = __webpack_public_path__ + "static/img/IMG_20150307_164025.4a380752.jpg";